import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import Colors from '../colors';

const Search = styled('div')(({ theme }) => ({
  borderRadius: '30px',
  backgroundColor: Colors.lightGray,
  '&:hover': {
    backgroundColor: Colors.lightGray2,
  },
  marginLeft: 0,
  width: '30ch',
  maxWidth: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
  },
  display: 'inline-flex'
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(1, 1, 0, 2),
}));

const ClearIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(1, 2, 0, 0),
}));

const SearchInput = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: 'inherit',
  fontFamily: 'Jost',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
  },
}));

function SearchBar({ placeholder = "Search Keyword", search, setSearch }) {
  const handleChange = (e) => {
    setSearch(e.target.value);
  }

  return (
    <Search>
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>
      <SearchInput
        placeholder={placeholder}
        onChange={handleChange}
        value={search}
      />
      {search && (
        <ClearIconWrapper>
          <ClearIcon
            onClick={() => setSearch("")} />
        </ClearIconWrapper>
      )}
    </Search>
  );
}

export default SearchBar;